export const buildPrelandingTemplate = (html, params) => {
  const { baseUrl, fbPixel, trackerUrl, subId1, subId2, subId3 } = params;

  if (!html) {
    return null;
  }

  const replaces = [
    { search: /#BASE_URL#/g, replace: baseUrl },
    { search: /#FBPX#/g, replace: fbPixel },
    { search: /#LINK#/g, replace: trackerUrl },
    { search: /#SubID1#/g, replace: subId1 },
    { search: /#SubID2#/g, replace: subId2 },
    { search: /#SubID3#/g, replace: subId3 },
  ];

  return replaces.reduce(
    (str, pair) => (pair.search && pair.replace ? str.replace(pair.search, pair.replace) : str),
    html,
  );
};

export default buildPrelandingTemplate;



// WEBPACK FOOTER //
// ./src/common/utils/buildPrelandingTemplate.js